import { Injector, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { isEmpty, filter } from 'lodash';
import { LinkExpirationServie } from '../../../Services/link-expiration/link-expiration';
import { BaseComponent } from '../../base.component';
import { NgSwitch } from '@angular/common';
import * as bowser from 'bowser';
import { find } from 'lodash';
@Component({
	selector: 'quote',
	template: `
		<div class="rate" [ngClass]="rateClass" *ngIf="showQuote">
			<h1>{{ control.attributes.rateTitle }}</h1>
			<p class="big" [ngClass]="{ 'no-dot': !yearly[1] }">
				{{ yearly[0] }} <span class="dot" *ngIf="yearly[1]">.</span>
				<sup>{{ yearly[1] }}</sup>
			</p>
			<p class="quote-number">
				Quote Number: <span>{{ selectedOption.quoteNum }}</span>
			</p>
		</div>
		<div *ngIf="showQuote" class="buy clearfix" [ngClass]="buyClass">
			<div class="content" [ngSwitch]="selectedOption.type" [ngClass]="selectedOption.type">
				<div *ngSwitchCase="'callNow'" id="curentQuote">
					<div class="sur">
						<h2>Buy this policy now!</h2>
						<p>
							Call us at
							<span class="phone">{{ control.attributes.phoNneum }}</span> or we'll call you
						</p>
						<call-me-now show-button="true"></call-me-now>
					</div>
					<
					<div class="sub">
						<p>Your home info is saved!, Continue with an expert.</p>
					</div>
				</div>

				<div *ngSwitchCase="'schedule'" id="curentQuote">
					<div class="sur">
						<h2>Buy this policy!</h2>
						<p>Schedule a call or call when we're open</p>
						<call-me-now show-button="true"></call-me-now>
					</div>
					<div class="sub clearfix">
						<div class="left">
							<h4>{{ control.attributes.phoneNum }}</h4>
							<p *ngFor="let option of control.attributes.availability">
								<span>{{ option.days }}</span> {{ option.hours }}
							</p>
						</div>
						<h5>{{ control.attributes.slogan1 }}<span>Continue with an expert</span></h5>
					</div>
				</div>

				<div *ngSwitchCase="'buyOnline'" id="curentQuote">
					<div class="sur">
						<h2 class="small-buyOnline">Buy this policy!</h2>
						<div>
							<button
								(click)="buyClicked()"
								[ngClass]="{ disabled: this.control.disabled }"
								class="requote-button {{ selectedOption.buyButton.attributes.buttonPosition }} {{
									selectedOption.buyButton.attributes.type
								}}"
								gtm-handler
								events="click"
								handlerType="button"
								label="Buy_Online_Button_Top"
								action="ButtonClick"
							>
								<span class="button-label desktop">{{ selectedOption.buyButton.attributes.label }}</span>
								<span class="button-label mobile">{{ setMobileLabel() }}</span>
							</button>
						</div>
						<p class="online-pohone">
							or call an expert at
							<a
								*ngIf="!bowser.mobile"
								class="phone small-buyOnline"
								[href]="dialNumber"
								[innerHtml]="selectedOption.phoneNum"
							></a>
							<a
								*ngIf="bowser.mobile"
								class="phone small-buyOnline"
								[href]="dialNumber"
								gtm-handler
								events="click"
								handlerType="dataValue"
								label="Call_Progressive"
								value="{{ dialNumber.replace('tel:', '') }}"
								action="LinkClick"
								[innerHtml]="selectedOption.phoneNum"
							></a>
						</p>
					</div>
				</div>

				<div *ngSwitchCase="'available'" id="curentQuote">
					<div class="sur">
						<h2 class="small-available">{{ control.attributes.title }}</h2>
						<div class="phone small-available">
							<a *ngIf="!isMObile()" class="number" [href]="dialNumber">{{ control.attributes.phoneNum }}</a>
							<a
								*ngIf="isMObile()"
								class="number"
								[href]="dialNumber"
								gtm-handler
								events="click"
								handlerType="dataValue"
								label="Call_Progressive"
								value="{{ dialNumber.replace('tel:', '') }}"
								action="LinkClick"
							>
								{{ control.attributes.phoneNum }}</a
							>
						</div>

						<div class="sub">
							<p>{{ control.attributes.slogan1 }}</p>
							<p>{{ control.attributes.slogan2 }}</p>
						</div>
					</div>
				</div>

				<div *ngSwitchCase="'unavailable'" id="curentQuote">
					<div class="sur">
						<h2 class="small-buyOnline">{{ control.attributes.title }}</h2>
						<p>{{ control.attributes.slogan1 }}</p>
						<p>{{ control.attributes.slogan2 }}</p>
					</div>
					<div class="sub">
						<div class="well clearfix">
							<div class="left">
								<p *ngFor="let option of control.attributes.availability" class="availability">
									<span class="days">{{ option.days }}</span>
									<span class="hours">{{ option.hours }}</span>
								</p>
							</div>
							<h5>{{ control.attributes.slogan3 }}</h5>
						</div>
						<div class="phone small-available">
							<a *ngIf="!isMObile()" class="number" [href]="dialNumber">{{ control.attributes.phoneNum }}</a>
							<a
								*ngIf="isMObile()"
								class="number"
								[href]="dialNumber"
								gtm-handler
								events="click"
								handlerType="dataValue"
								label="Call_Progressive"
								value="{{ dialNumber.replace('tel:', '') }}"
								action="LinkClick"
							>
								{{ control.attributes.phoneNum }}</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./quote.component.scss'],
})
export class QuoteComponent extends BaseComponent implements OnInit {
	selectedOption: any;
	dialNumber: any;
	bowser: any;
	showQuote: boolean;
	rateClass: string;
	buyClass: string;

	constructor(injector: Injector, private linkExpiration: LinkExpirationServie) {
		super(injector);
	}

	ngOnInit() {
		this.selectedOption = this.getSelection();
		this.bowser = bowser;
		if (this.selectedOption && this.selectedOption.buyButton) {
			this.linkExpiration.setLinkExpiration(this.selectedOption.buyButton.attributes.ReQuotedData);
		}
		this.observablesService.insurerSelected.subscribe(() => {
			this.selectedOption = this.getSelection();
			if (this.selectedOption && this.selectedOption.buyButton) {
				this.linkExpiration.setLinkExpiration(this.selectedOption.buyButton.attributes.ReQuotedData);
			}
		});
		this.rateClass = this.getRateClass();
		this.buyClass = this.getBuyClass();
	}

	get yearly() {
		return this.selectedOption && this.selectedOption.year.split('.');
	}

	getSelection() {
		this.dialNumber = 'tel:' + this.control.attributes.phoneNum;
		let selected = this.storeService.getValue('CarrierInformation', this.context);
		this.showQuote = !selected.hasPackage;

		return find(this.control.attributes.options, { name: selected.name });
	}

	setHref() {
		return this.control.disabled
			? ''
			: !isEmpty(this.selectedOption.buyButton.attributes.url)
			? this.selectedOption.buyButton.attributes.url
			: '';
	}

	hasUrl() {
		return !isEmpty(this.selectedOption.buyButton.attributes.url);
	}

	setMobileLabel() {
		return !isEmpty(this.selectedOption.buyButton.attributes.mobilelabel)
			? this.selectedOption.buyButton.attributes.mobilelabel
			: this.selectedOption.buyButton.attributes.label;
	}

	buyButtonClick() {
		if (
			!this.linkExpiration.validateLinkExpiration(
				this.selectedOption.buyButton.ajaxInfo,
				this.selectedOption.buyButton.attributes.ReQuotedData
			)
		) {
			this.selectedOption.buyButton.attributes.url = '';
		}
		this.control.ajaxInfo = this.selectedOption.buyButton.ajaxInfo;
		this.value = this.storeService.getValue('CarrierInformation', this.context);
		this.actionService.ajaxAction(this.control.ajaxInfo, this.context);
	}

	isMObile() {
		const bowserType = bowser.getParser(window.navigator.userAgent).getPlatformType();
		return bowserType === 'mobile';
	}

	getRateClass() {
		let type = this._isBuyOnlineOrAvailable();
		if (type) {
			return `${type}-rate-small`;
		}
		return '';
	}

	getBuyClass() {
		let type = this._isBuyOnlineOrAvailable();
		if (type) {
			return `${type}-buy-small`;
		}
		return '';
	}

	_isBuyOnlineOrAvailable() {
		let val;
		switch (this.selectedOption.type) {
			case 'buyOnline':
				val = 'buyOnline';
				break;
			case 'available':
				val = 'available';
				break;
			case 'unavailable':
				val = 'unavailable';
				break;
			default:
				val = false;
				break;
		}
		return val;
	}

	buyClicked() {
		const location = this.control.disabled ? '' : this.setHref();
		!this.control.disabled &&
			(!this.hasUrl() || this.selectedOption.buyButton.attributes.mixaction) &&
			this.buyButtonClick();
		!isEmpty(location) && window.open(location, '_self');
	}
}
